import { AppContext } from 'contexts/AppContext'
import React, { useContext } from 'react'
import { createUseStyles } from 'react-jss'

const jss = createUseStyles({
    roundIconButton2: {
        backgroundColor: (styleGuide) => styleGuide.color18,
        color: (styleGuide) => styleGuide.color1,
        borderRadius: '50%',
        height: (styleGuide) => styleGuide.roundButtonSize,
        width: (styleGuide) => styleGuide.roundButtonSize,
        fontWeight: '600',
        border: 'none',
        padding: '9px 8px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        
        '&:hover':{
            backgroundColor: (styleGuide) => styleGuide.color16,
        },
        
        '&:disabled':{
            backgroundColor: (styleGuide) => styleGuide.color18,
            opacity: 0.7,
            cursor: 'not-allowed'
        }
    }
})

const RoundIconButton2 = (props) => {
    const { styleGuide } = useContext(AppContext)
    const classes = jss(styleGuide)
    
    return (
        <button
            onClick={props.onClick}
            style={{...props.style}}
            disabled={props.disabled}
            className={`${classes.roundIconButton2} ${props.className}`}
        > 
            {props.icon}
        </button>
    )
}

export default RoundIconButton2;